import { markRaw } from 'vue'

import {
  HIDDEN_INTERVAL,
  promiseInterval,
} from 'src/services/promise_interval/promise_interval.js'

// A promiseInterval that can be started and stopped any number of times;
// starting a running poller does nothing. call should return its promise,
// so the next call waits for it. In a hidden tab it polls once a minute.
export const createPoller = (call, interval) => {
  let loop = null

  return {
    get running() {
      return loop !== null
    },
    start() {
      loop ??= promiseInterval(call, interval, {
        hiddenInterval: HIDDEN_INTERVAL,
      })
    },
    stop() {
      loop?.stop()
      loop = null
    },
  }
}

// startFetching/stopFetching actions for a store that polls: load gets the
// store and returns its promise. The store keeps `poller: null` in state.
export const pollingActions = (load, interval) => ({
  startFetching() {
    this.poller ??= markRaw(createPoller(() => load(this), interval))
    this.poller.start()
  },
  stopFetching() {
    this.poller?.stop()
  },
})
